import { BifrostBackendApi, BifrostBackendNestApi } from "../../gateways/BifrostBackendApi";
import { store } from "../../store";
import {SET_GLOBAL_INFO_DIALOG} from "../../store/mutation-types";
import LoggerProvider from "../LoggerProvider";

const PersonServiceProvider = {
	baseUrl: `/person`,
	nestBaseUrl: `/users`,
	nestIntBaseUrl: `intusr/users`,
	async createPerson(tenantId, user ) {
		return BifrostBackendApi.post(`${this.baseUrl}?tenantId=${tenantId}`, user);
	},
	async deletePerson(tenantId, token) {
		return BifrostBackendNestApi.delete(`${this.nestBaseUrl}/remove`, {
			params: { tenantId: tenantId },
			headers: {
				Authorizationidp: token
			}
		});
	},
	async updatePerson(tenantId, token, user) {
		if (store.getters.subscriptionExistsData.useNewSubscriptionEndPoint) {
			return BifrostBackendNestApi.put(`${this.nestBaseUrl}`, user, {
				headers: {
					Authorizationidp: token
				}
			});
		} else {
			return BifrostBackendApi.put(`${this.baseUrl}/${token}`, user, {
				params: { tenantId: tenantId },
				headers: {
					Authorizationidp: token
				}
			});
		}
	},
	async getPersonData(tenantId, token) {
		const personQueryParams = {
			tenantId
		};
		return BifrostBackendNestApi.get(`${this.nestIntBaseUrl}/details`, {
			params: personQueryParams,
			headers: {
				Authorizationidp: token
			}
		});
	},
	async verifyPersonExistsByEmail(tenantId, email) {
		const personQueryParams = {
			tenantId,
			email: encodeURIComponent(email)
		};
		try {
			// we need to await here if we want to catch the error
			return await BifrostBackendNestApi.get(this.nestIntBaseUrl, {
				params: personQueryParams
			});
		} catch (error) {
			// in case of too many requests, we want to show a specific message to the user and not to block the app
			// we'll also log this event in our logger for sake of analysis - but we could also remove this at some point
			if (error.response.status === 429) {
				store.commit(SET_GLOBAL_INFO_DIALOG, "utilityComponents.modalComponent.messages.tooManyRequests");
				LoggerProvider.logEvent({
					message: "Failed to verify if person exists due to too many requests.",
					eventName: "PersonServiceFailure",
					eventCategory: "EmailSubmission",
					eventDomain: "UserAuth",
					data: {
						error: error.message
					}
				});
				return null;
			} else {
				// if error is not related to too many requests, we want to throw it further - and it should be handled by the caller
				throw error;
			}
		}
	}
};

export default Object.freeze(PersonServiceProvider);
